"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InfinitySign;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function InfinitySign(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "infinitySign"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M73.4,30.9a19.036,19.036,0,0,0-13.079,5.183L50,46.394,39.618,36.015a19.115,19.115,0,1,0,.066,27.906L50,53.605l10.382,10.38A19.1,19.1,0,1,0,73.4,30.9ZM36.213,60.323a14.109,14.109,0,1,1-.066-20.711L46.535,50ZM73.4,64.105a14.053,14.053,0,0,1-9.542-3.717L53.465,50,63.787,39.676A14.1,14.1,0,1,1,73.4,64.105Z"
  }))));
}